// extracted by mini-css-extract-plugin
export var header = "_v1-1";
export var maskBottom = "_v1-6";
export var maskMiddle = "_v1-7";
export var maskTop = "_v1-5";
export var root = "_v1-0";
export var scrollDownButton = "_v1-3";
export var scrollDownButtonHidden = "_v1-4";
export var viewport = "_v1-2";